"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _label = _interopRequireWildcard(require("./label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _textarea = _interopRequireDefault(require("./textarea.scss"));

var _field = require("./field");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Textarea = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Textarea, _Component);

  function Textarea() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Textarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Textarea)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      value: _this.props.value
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderLabel", function (id) {
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_label["default"], {
        className: (0, _classnames["default"])(_this.props.classNames.label, (0, _defineProperty2["default"])({}, _textarea["default"].errorLabel, _this.props.errorMessage)),
        tooltip: _this.props.tooltip,
        "for": id
      }, _this.props.label), _react["default"].createElement(_label.SubLabel, {
        className: (0, _classnames["default"])(_this.props.classNames.subLabel, (0, _defineProperty2["default"])({}, _textarea["default"].errorLabel, _this.props.errorMessage))
      }, _this.props.subLabel));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderField", function (id) {
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_textarea["default"].fieldIconContainer, (0, _defineProperty2["default"])({}, _textarea["default"].TextareaHorizontal, _this.props.isHorizontal))
      }, _react["default"].createElement("textarea", {
        ref: _this.props.innerRef,
        type: _this.props.type,
        name: _this.props.name,
        autoComplete: _this.props.autoComplete,
        autoCorrect: _this.props.autoCorrect,
        id: id,
        value: _this.state.value,
        className: (0, _classnames["default"])(_textarea["default"].field, (0, _defineProperty2["default"])({}, _textarea["default"].fieldInvalid, _this.props.errorMessage), _this.props.classNames.field),
        pattern: _this.props.pattern,
        disabled: _this.props.disabled,
        placeholder: _this.props.placeholder,
        "aria-label": _this.props.ariaLabel,
        onChange: _this.onChange,
        onBlur: _this.props.onBlur,
        onFocus: _this.props.onFocus
      }, _this.state.value), _this.props.maxLength && _react["default"].createElement("div", {
        className: _textarea["default"].characterCountWrapper
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_textarea["default"].characterCount, (0, _defineProperty2["default"])({}, _textarea["default"].error, _this.exceedsMaxLength()))
      }, _this.getCharacterCount()))), _this.props.errorMessage && _react["default"].createElement(_errorMessage["default"], {
        message: _this.props.errorMessage,
        className: _this.props.classNames.errorMessage
      }));
    });
    return _this;
  }

  (0, _createClass2["default"])(Textarea, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value && prevProps.value !== this.props.value) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: "getSuggestedLength",
    value: function getSuggestedLength() {
      return this.props.suggestedLength || this.props.maxLength;
    }
  }, {
    key: "getCharacterCount",
    value: function getCharacterCount() {
      return this.getSuggestedLength() - this.state.value.length;
    }
  }, {
    key: "exceedsMaxLength",
    value: function exceedsMaxLength() {
      return this.state.value.length > this.getSuggestedLength();
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id || (0, _field.makeIdString)();
      var wrapperOpts = {
        isHorizontal: this.props.isHorizontal,
        classNames: this.props.classNames
      };
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_textarea["default"].Textarea, this.props.classNames.wrapper, (0, _defineProperty2["default"])({}, _textarea["default"].TextareaHorizontal, this.props.isHorizontal))
      }, (0, _field.wrapIfHorizontal)(_objectSpread({}, wrapperOpts, {
        type: 'Label'
      }), this.renderLabel(id)), (0, _field.wrapIfHorizontal)(_objectSpread({}, wrapperOpts, {
        type: 'Field'
      }), this.renderField(id)));
    }
  }]);
  return Textarea;
}(_react.Component);

exports["default"] = Textarea;
Textarea.propTypes = _field.textfieldPropTypes;
Textarea.defaultProps = {
  type: 'text',
  value: '',
  classNames: {}
};